<template lang="pug">
#ListParts
  .container-list
    b-card(border-variant="light")
      strong Ingresar Búsqueda
      b-row
        b-col(md="6" sm="12")
          b-input-group.mt-2
            b-input-group-prepend
              b-button(@click="handleSearch" variant="light")
                b-icon(icon="search" variant="muted" size="md")
            b-form-input(
              v-model="search"
              placeholder="Ingresar el Código de la Pieza / Descripción / Ubicación Real"
              @keydown.enter="handleSearch"
              @keydown.esc="handleClear"
            )
            b-input-group-append
              b-button(@click="handleClear" variant="light")
                b-icon(icon="x" variant="muted" size="md")
        b-col(md="6").d-none.d-md-block
          b-button.mt-2(variant="button" to="/inventario/ingreso-inventario/ingreso") + Ingresar Nuevo
          b-button.mt-2.ml-3.btn-ingreso(variant="estado-yellow" to="/inventario/ingreso-inventario/drop") Rebaja DROP
          b-button.mt-2.ml-3.btn-ingreso(variant="estado-red" to="/inventario/ingreso-inventario/scrap-bad") SCRAP BAD
          b-button.mt-2.ml-3.btn-ingreso(variant="button-light" to="/inventario/ingreso-inventario/scrap-good") SCRAP GOOD
          b-button.mt-2.ml-3.btn-ingreso(variant="estado-green" to="/inventario/ingreso-inventario/rtv") RTV
          b-button.mt-2.ml-3.btn-ingreso(variant="estado-red" to="/inventario/ingreso-inventario/slow") SLOW   
          b-button.mt-2.ml-3(variant="button", @click="exportExcel()") Exportar Piezas     
        b-col(sm="12" class="d-block d-md-none ").mt-2
          b-dropdown(text="Opciones" variant="button" menu-class=" dropdown-menu" right)
            b-dropdown-item
              b-button.mt-2.btn-responsive(variant="primary" class="text-white" to="/inventario/ingreso-inventario/ingreso") Ingresar Nuevo
            b-dropdown-item
              b-button.mt-2.btn-ingreso(variant="estado-yellow" to="/inventario/ingreso-inventario/drop") Rebaja DROP
            b-dropdown-item
              b-button.mt-2.btn-ingreso(variant="estado-red" to="/inventario/ingreso-inventario/scrap-bad") SCRAP BAD
            b-dropdown-item
              b-button.mt-2.btn-ingreso(variant="button-light" to="/inventario/ingreso-inventario/scrap-good") SCRAP GOOD
            b-dropdown-item
              b-button.mt-2.btn-ingreso(variant="estado-green" to="/inventario/ingreso-inventario/rtv") RTV
            b-dropdown-item
              b-button.mt-2.btn-ingreso(variant="estado-red" to="/inventario/ingreso-inventario/slow") SLOW
            b-dropdown-item
              b-button.mt-2.btn-responsive(variant="primary" class="" @click="exportExcel()") Exportar Piezas  
     
    b-table(
      :items="tableItems",
      :fields="fields",
      head-row-variant="light-primary",
      thead-class="text-black tabla-thead",
      tbody-class="tabla-tbody",
      tbody-tr-class="bg-white",
      responsive,
      :busy="loading",
      show-empty,
      empty-text="No hay Piezas disponibles"
    )
      template(#cell(part_number)='value')
        .d-flex.justify-content-start
          router-link(:to="`/inventario/historial-pieza/${value.item.part_number}/${value.item.id}`" style="font-weight: bold;") {{value.item.part_number}}
      template(#cell(real_location)='value')
        .d-flex.justify-content-start
          div(style="font-weight: bold; color:#253590") {{value.item.real_location}}
      template(#cell(cantidad_allocated)='value')
        .d-flex.justify-content-start
          div.clickable-cell(@click="openRMAModal('allocated', value.item)") {{value.item.cantidad_allocated}}
      template(#cell(cantidad_drop)='value')
        .d-flex.justify-content-start
          div.clickable-cell(@click="openRMAModal('drop', value.item)") {{value.item.cantidad_drop}}
      template(#cell(cantidad_malos)='value')
        .d-flex.justify-content-start
          div.clickable-cell(@click="openRMAModal('malos', value.item)") {{value.item.cantidad_malos}}
      template(#table-busy)
        div(class="text-center text-danger my-2")
          b-spinner(class="align-middle")
  .d-flex.flex-row-reverse
    b-pagination(
      v-model="currentPage",
      :total-rows="count",
      :per-page="pageSize",
      prev-text="Ant.",
      next-text="Sig.",
      @change="handlePageChange"
    )
  
  // Modal de detalles de partes
  PartsModal(
    :visible="showRMAModal"
    :selected-item="selectedItem"
    :selected-type="selectedType"
    @close="closeModal"
  )
</template>
<script>
import { mapActions } from 'vuex'
import Loader from '../UI/Loader.vue'
import PartsModal from './PartsModal.vue'

export default {
  name: 'ListParts',
  components: {
    Loader,
    PartsModal,
  },
  data() {
    return {
      search: '',
      currentPage: 1,
      pageSize: 20,
      tableItems: [],
      count: 0,
      loading: false,
      showRMAModal: false,
      selectedItem: {},
      selectedType: '',
      fields: [
        { key: 'part_number', label: 'Código de la Pieza', sortable: true },
        { key: 'real_location', label: 'Ubicación Real', sortable: true },
        { key: 'description', label: 'Descripción' },
        { key: 'cantidad_buenos', label: 'Buenos', sortable: true },
        { key: 'cantidad_allocated', label: 'Allocated', sortable: true },
        { key: 'cantidad_drop', label: 'Drop', sortable: true },
        { key: 'cantidad_malos', label: 'Malos', sortable: true },
      ],
    }
  },
  methods: {
    ...mapActions('PartsStore', ['listParts', 'getPartsExcel']),
    exportExcel() {
      this.getPartsExcel();
    },
    async handlePageChange(page) {
      this.fetchData(page)
    },
    async fetchData(page = 1) {
      this.loading = true
      const res = await this.listParts({ page, search: this.search })
      this.tableItems = res.results
      this.count = res.count
      this.loading = false
    },
    handleSearch() {
      this.fetchData(this.currentPage)
    },
    handleClear() {
      this.search = ''
      this.fetchData(this.currentPage)
    },
    openRMAModal(type, item) {
      this.selectedType = type
      this.selectedItem = item
      this.showRMAModal = true
    },
    closeModal() {
      this.showRMAModal = false
      this.selectedItem = {}
      this.selectedType = ''
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
<style lang="scss">
@import '@/style/colors.scss';

.container-list {
  box-shadow: 0px 3px 6px #00000029;
}
.btn-ingreso {
  width: 130px;
  color: $samtek-black !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  align-items: center;
}
.btn-responsive {
  width: 130px;
  font-weight: bold !important;
  font-size: 14px !important;
  align-items: center;
}
.modal-body{
  padding: 0.2rem 1rem !important;
}
.clickable-cell {
  cursor: pointer;
  color: $blue-accent !important;
  // font-weight: bold;
  
  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
}

.modal-table {
  .table {
    margin-bottom: 0;
    table-layout: fixed; // Fuerza que la tabla respete los anchos establecidos
    max-width: 480px;
    
    td {
      padding: 0.5rem;
      word-wrap: break-word; // Permite que el texto largo se ajuste
      overflow-wrap: break-word;
    }
    
    th {
      padding: 0.5rem;
      background-color: #f8f9fa00;
      font-weight: 600;
      word-wrap: break-word;
    }
    tr {
      border: 0 !important;
    }
    
    // Alineación específica para las columnas de la tabla del modal
    ::v-deep .text-left {
      text-align: left !important;
    }
    
    ::v-deep .text-center {
      text-align: center !important;
    }
    
    ::v-deep .text-right {
      text-align: right !important;
    }
  }
}
.row-title{
  display: flex;
  align-items: center;
}
.title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

// Iconos de ordenamiento en gris ($samtek-grey)
$sort-svg: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>";
$sort-up: "<path fill='%23525252' d='M50 8l38 44H12z'/>";
$sort-up-soft: "<path fill='%23525252' opacity='.5' d='M50 8l38 44H12z'/>";
$sort-down: "<path fill='%23525252' d='M50 92L12 48h76z'/>";
$sort-down-soft: "<path fill='%23525252' opacity='.5' d='M50 92L12 48h76z'/>";
$sort-end: "</svg>";

$sort-icon: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down-soft}#{$sort-end}");
$sort-icon-asc: url("#{$sort-svg}#{$sort-up}#{$sort-down-soft}#{$sort-end}");
$sort-icon-desc: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down}#{$sort-end}");

// Estilos del componente, anidados para no filtrar al resto de la app
#ListParts {
  // Buscador
  .input-group {
    width: 397px;
    max-width: 100%;
    flex-wrap: nowrap;

    .form-control {
      height: 45px;
      min-width: 0;
      font-size: 15px;
      color: $samtek-black;
      background-color: #fff;
      border: 1px solid $samtek-grey;
      border-radius: 8px;

      &:focus {
        border-color: $samtek-grey;
        box-shadow: none;
      }

      &::placeholder {
        color: $samtek-grey;
        font-size: 15px;
      }
    }

    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 45px;
      height: 45px;
      padding: 0;
      border: none;
      background-color: transparent;
      box-shadow: none;

      &:hover,
      &:focus,
      &:active {
        background-color: $center-bg;
        box-shadow: none;
      }

      .b-icon {
        color: $samtek-grey !important;
      }
    }

    .input-group-prepend .b-icon {
      color: $samtek-yellow !important;
    }
  }

  // Fila de botones de acción
  .col-md-6.d-md-block {
    @media (min-width: 768px) {
      display: flex !important;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
    }

    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 45px;
      padding: 0 20px;
      margin: 0 !important;
      border-radius: 8px;
      font-weight: 600;
    }

    // Ingresar Nuevo
    > .btn:first-child {
      color: $samtek-black;
      background-color: $samtek-yellow;
      border: 1px solid $samtek-yellow;

      &:hover,
      &:focus,
      &:active {
        color: $samtek-black;
        background-color: $samtek-yellow;
        border-color: $samtek-yellow;
      }
    }

    // Rebaja DROP / SCRAP BAD / SCRAP GOOD / RTV / SLOW
    .btn-ingreso {
      width: auto;
      color: $samtek-black !important;
      background-color: #fff;
      border: 1px solid $samtek-yellow;

      &:hover,
      &:focus,
      &:active {
        color: $samtek-black !important;
        background-color: $samtek-yellow;
        border-color: $samtek-yellow;
      }
    }

    // Exportar Piezas
    > .btn:last-child {
      color: $samtek-black;
      background-color: #fff;
      border: 1px solid $table-head-bg;

      &:hover,
      &:focus,
      &:active {
        color: $samtek-black;
        background-color: $center-bg;
        border-color: $table-head-bg;
      }
    }
  }

  // Tabla
  .b-table {
    margin-bottom: 0;

    thead th {
      height: 50px;
      padding: 0 40px;
      font-size: 16px;
      font-weight: 700;
      color: $samtek-grey !important;
      background-color: $table-head-bg;
      border: none;
      vertical-align: middle;
    }

    thead th[aria-sort] {
      background-size: 16px 16px;
      background-position: right 16px center;
    }

    thead th[aria-sort='none'] {
      background-image: $sort-icon;
    }

    thead th[aria-sort='ascending'] {
      background-image: $sort-icon-asc;
    }

    thead th[aria-sort='descending'] {
      background-image: $sort-icon-desc;
    }

    tbody tr {
      height: 50px;
      background-color: #fff;
    }

    tbody td {
      height: 50px;
      padding: 0 40px;
      font-size: 15px;
      color: $samtek-black;
      background-color: #fff;
      border: none;
      vertical-align: middle;
    }

    tbody td:first-child {
      font-weight: 700;
    }

    // Columnas numéricas: Buenos, Allocated, Drop, Malos
    tbody td:nth-child(n + 4) {
      font-weight: 500;
      color: $blue-accent !important;
      text-align: right;

      .d-flex {
        justify-content: flex-end !important;
      }
    }
  }

  // Paginación
  .page-link {
    color: $samtek-grey;
    background-color: #fff;
    border: 1px solid $table-head-bg;

    &:hover {
      color: $samtek-grey;
      background-color: $center-bg;
      border-color: $table-head-bg;
      box-shadow: none;
    }
  }

  .page-item.active .page-link {
    color: $samtek-black;
    background-color: $samtek-yellow;
    border-color: $samtek-grey;
  }

  .page-item.disabled .page-link {
    color: $samtek-grey;
    background-color: #fff;
    border: 1px solid $table-head-bg;
  }
}

</style>
